import React from "react";
import HomeView from "./Views/HomeView";
import { useNavigate } from "react-router-dom";
import { observer } from "mobx-react-lite";

const HomePresenter = observer(({ model }) => {
  const navigate = useNavigate();

  const handleQueryChange = (query) => model.setQuery(query);

  const handleSearch = async () => {
    const query = model.getQuery();
    if (!query.trim()) return;
    await model.searchArtworks();
    navigate(`/browse?query=${encodeURIComponent(query)}`);
  };

  //load random artworks when the presenter initializes.
  if (model.randomArtworks.length === 0) {
    model.loadRandomArtworks(8); 
  }

  return (
    <>
      <HomeView
        query={model.getQuery()}
        setQuery={handleQueryChange}
        onSearch={handleSearch}
        loading={model.loading}
        artworks={model.randomArtworks}
      />
    </>
  );
});

export default HomePresenter;
